// extracted by mini-css-extract-plugin
export default {"wrapper":"ResetFilters_wrapper__4qToe","imgBlock":"ResetFilters_imgBlock__s94Im","img":"ResetFilters_img__sWLjs"};